import {
  definitions,
  operations,
  paths,
} from "../../common-fetch/generated/orders-model-api";
import { fetchItJson } from "../../common-fetch/miscellaneous/fetchItJson";
import { FetchOutput } from "../../common-fetch/miscellaneous/fetchResult";
import { getPartnerPathnameClient } from "../../getPartnerPathnameClient";

type Path = paths["/carts"];
type Responses = Path["get"]["responses"];

export type FetchPostCartInput =
  operations["CartPost"]["parameters"]["body"]["body"];

export type FetchPostCartOutput = FetchOutput<
  Responses["200"]["schema"],
  definitions["ProblemDetails"]
>;

export async function fetchDeleteCart(): Promise<FetchPostCartOutput> {
  const path: keyof paths = "/carts";

  return fetchItJson<Responses["200"]["schema"], definitions["ProblemDetails"]>(
    "authorization",
    `${getPartnerPathnameClient(true)}/Market/HostedCart/Orders/v1${path}`,
    {
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
    }
  ).catch(() => {
    return { tag: "client-error", parsed: { status: 418 } };
  });
}
